import { NUMBER_EMOJIS } from '../constants/numberEmojis';

type GetNumberEmojis = (input: number) => string;

const getNumberEmojis: GetNumberEmojis = (input) => (
  input.toString().split('').map((s) => NUMBER_EMOJIS[s] || '').join('')
);

export { getNumberEmojis };
